import React, {useMemo} from 'react'
import styled, {css} from 'styled-components'

import ContentWrapper from 'components/contentWrapper';
import ContentArea from 'components/contentArea';

type Props = {
  product: any
};

// Product Delivery
const Component: React.FC<Props> = (props) => {

  return (
    <StyledComponent className="productDelivery spacingTop">

      <ContentWrapper>
        <h3 className="spacingBottomHalf">Delivery Information</h3>
      </ContentWrapper>

      <ContentArea content={props.product?.content?.delivery_info} />

    </StyledComponent>
  );

}


export default Component;


// Styles
const StyledComponent = styled.div`

  display: block;
  padding-bottom: 5rem;

`;



